var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"favorite-cta",class:{
        'preview': _vm.location === 'preview',
        'title': _vm.location === 'title'
    },attrs:{"id":"gtm-plotcard-cta-favorite","fab":_vm.location === 'header',"elevation":_vm.location === 'header' ? 2 : 0,"small":"","icon":""},on:{"click":function($event){$event.preventDefault();return _vm.toggleFavorite()}}},[_c('v-icon',{staticClass:"icon",class:{
            'active-heart icon-favorite': _vm.isFavorite,
            'icon-empty-favorite' : !_vm.isFavorite,
            'h2': _vm.location === 'title'
        }})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4c1ac12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plotInformation/components/Favorite.vue
// module id = null
// module chunks = 